import styled from 'styled-components'

export const Flex = styled.div`
display: flex;
`

export const Column = styled(Flex)`
flex-direction: column;
`
